// extracted by mini-css-extract-plugin
export default {"select-url-pill__url":"select-url-pill__url-WlflS","select-url-pill__page-label":"select-url-pill__page-label-D6dqw","select-pill-url__main":"select-pill-url__main-LCfVT"};